<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {usePiniaStore} from "../store/pinia_store";
import {debounce} from "lodash";
import {storeToRefs} from "pinia";

const props = defineProps({
    dentaidApiInstance: {
        type: Function,
        required: true,
    },
    cartEventBus: {
        type: Object,
        required: true,
    },
    eventBus: {
        type: Object,
        required: true,
    }
})

const piniaStore = usePiniaStore();
const { cart } = storeToRefs(piniaStore);

const cartItems = ref(0);

const hasCartItems = computed(() => {
    return cartItems.value > 0;
})

const getCartItemCount = () => {
    cartItems.value = piniaStore.cart?.lines_quantity ?? 0;
}

watch(() => cart.value, debounce(() => {
    getCartItemCount();
}, 250))

onMounted(() => {
    props.eventBus.$on('alive', () => getCartItemCount());
})
</script>

<template>
    <div class="vue-cart-badge badge" v-if="hasCartItems">
        {{ cartItems }}
    </div>
</template>
